export default __webpack_public_path__ + "static/public-safety-accomplishment-3-4cc38893226dbc1acaa2b7c57e4da5b9.webp";